import { render, staticRenderFns } from "./BaseTravelTime.vue?vue&type=template&id=8823e2ec&scoped=true"
import script from "./BaseTravelTime.vue?vue&type=script&lang=js"
export * from "./BaseTravelTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8823e2ec",
  null
  
)

export default component.exports